import texasAMLogo from '../assets/logos/TAMUWhiteLogo.svg';

export const Footer = () => {
  return (
    <footer className="z-10 flex h-16 w-full items-center justify-between bg-banner">
      <div className="flex w-full items-center justify-between px-8 text-white md:px-12">
        <div className="flex items-center">
          <p>© All rights reserved</p>
          {/* TODO: Add feedback link back in when we go live */}
          {/* <div className="flex items-center justify-center">
            <Button
              onClick={() => {
                // TODO: Add feedback link here
              }}
            >
              <ChatBubbleLeftIcon className="w-6" /> Provide feedback
            </Button>
          </div> */}
        </div>
        <div className="flex items-center gap-8">
          <a className="text-sm font-normal underline" href="mailto:tdis@tamu.edu">
            Contact Help Desk
          </a>
          <a
            href="https://www.tamu.edu/index.html"
            target="_blank"
            rel="noreferrer"
            aria-label="Texas A&M University logo"
            className="mx-0"
          >
            <img src={texasAMLogo} alt="Texas A&M logo" className="h-16" />
          </a>
        </div>
      </div>
    </footer>
  );
};
